export const FILTER_STATISTICS_QUERY_KEY = 'filter-statistics';

export const GET_INDEXABLE_FILTERS_QUERY_KEY = 'get-indexable-filter';

export const FILTER_NOTIFICATIONS_QUERY_KEY = 'filter-notifications';

export const CATALOG_CATEGORIES_QUERY_KEY = 'catalog-categories';

export const CATEGORY_FILTER_W_COUNT_QUERY_KEY = 'category-filter-w-count';

export const GET_ACTIVATED_SUGGESTED_QUERY_KEY = 'get-activated-filters';

export const SUGGESTED_FILTERS_FOR_CATEGORY_QUERY_KEY =
  'suggested-filters-for-category';

export const HFB_CATEGORIES_MAPPING_QUERY_KEY = 'hfb-categories-mapping';

export const MARKET_FILTER_REQUESTS_QUERY_KEY = 'market-filter-requests';
